export default "__VITE_ASSET__BYwTPpaO__"